<section class="bg-gray-50 dark:bg-gray-900">
  <div class="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
    <a
      routerLink="/login"
      class="mb-8 flex w-full max-w-lg shrink-0 flex-col items-center justify-center px-2 text-2xl font-semibold text-gray-900 no-underline dark:text-white"
      aria-label="Redal — início"
    >
      <img
        class="block h-auto w-full max-h-[min(48vh,240px)] max-w-[min(320px,calc(100vw-3rem))] object-contain object-center"
        src="./assets/img/logo_preto.png"
        alt="Redal"
        loading="eager"
        decoding="async"
      />
    </a>
    <div
         class="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
      <div class="p-6 space-y-4 md:space-y-6 sm:p-8">
        <form class="space-y-4 md:space-y-6" (keyup.enter)="onSubmit()" [formGroup]="loginForm">
          <div>
            <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">E-mail</label>
            <input type="email" name="email" id="email" formControlName="username"
                   class="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                   placeholder="" />
            <p *ngIf="f['username'].touched && f['username'].invalid" class="mt-1 text-xs text-red-500">
              Informe um e-mail válido.
            </p>
          </div>

          <div>
            <label for="password" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Senha</label>
            <input autocomplete="current-password" type="password" id="password" name="password"
                   formControlName="password"
                   class="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
            <p *ngIf="f['password'].touched && f['password'].invalid" class="mt-1 text-xs text-red-500">
              A senha deve ter pelo menos 4 caracteres.
            </p>
          </div>

          <div class="flex items-center justify-between">
            <div class="flex items-start">


            </div>
          </div>

          <button [disabled]="loginForm.invalid || isSubmitting" (click)="onSubmit()" type="button"
                  class="w-full text-white bg-amber-700 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 disabled:opacity-50 disabled:cursor-not-allowed">
            Entrar
          </button>

          <div class="text-center">
            <p>V.1.0.9</p>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
